const mediaItems = [
  {
    title: '《暗夜追光》终极预告片',
    tag: '悬疑犯罪 · 预告',
    duration: '02:35',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20suspenseful%20crime%20drama%20trailer%20thumbnail%20with%20dramatic%20movie%20poster%20style%2C%20noir%20lighting%2C%20mysterious%20shadow%20figure%2C%20golden%20accent%20light%20streak%2C%20cinematic%20composition%2C%20film%20noir%20aesthetic%2C%20professional%20movie%20poster%20quality&width=800&height=450&seq=media-01-trailer&orientation=landscape',
  },
  {
    title: '《长安浮生录》制作特辑',
    tag: '古装权谋 · 幕后',
    duration: '08:12',
    imageUrl: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20historical%20Chinese%20drama%20production%2C%20traditional%20costume%20details%2C%20film%20set%20with%20warm%20lighting%2C%20director%20and%20actors%20discussing%2C%20elegant%20period%20aesthetic%2C%20professional%20film%20production%20atmosphere&width=800&height=450&seq=media-02-behind&orientation=landscape',
  },
  {
    title: '「暑期追剧指南」官方混剪',
    tag: '专题策划 · 混剪',
    duration: '05:48',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20movie%20montage%20collage%20thumbnail%20with%20colorful%20film%20strips%2C%20dynamic%20composition%20of%20different%20genres%2C%20summer%20vibe%20with%20warm%20sunset%20tones%2C%20energetic%20cinematic%20style%2C%20movie%20poster%20elements%20blended%20artistically&width=800&height=450&seq=media-03-mashup&orientation=landscape',
  },
  {
    title: '《星际迷途3》视觉特效解析',
    tag: '科幻巨制 · 特效',
    duration: '04:20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20visual%20effects%20breakdown%20thumbnail%2C%20digital%20wireframe%20and%20final%20render%20comparison%2C%20space%20scene%20with%20nebulae%2C%20cinematic%20lighting%2C%20behind%20the%20scenes%20VFX%20studio%20aesthetic%2C%20professional%20CGI%20composition&width=800&height=450&seq=media-04-vfx&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500">预告片、幕后花絮与专题混剪，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300 hover:shadow-lg transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={`黄瓜影院${item.tag} - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {/* Play button overlay */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                {/* Duration badge */}
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-foreground-900/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-1.5">
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-foreground-700 rounded-full text-sm font-medium border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看更多视频
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}